import axios from "axios";
import { zafClient } from "./zendesk";
let api: ReturnType<typeof axios.create>;
let telecontrol: string;
let maps_key: string;
let baseURL: string;

const initializeConfig = async () => {
  try {
    const metadata = await zafClient.metadata();

    telecontrol = metadata.settings.telecontrol;
    baseURL = metadata.settings.apiUrl;
    maps_key = metadata.settings.mapsApiKey || "";

    api = axios.create({
      baseURL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error("Erro ao carregar configurações do manifest.json:", error);
    throw error;
  }
};

const ensureInitialized = async () => {
  if (!api) {
    await initializeConfig();
  }
};

export { initializeConfig, ensureInitialized, api, telecontrol, maps_key, baseURL };
